<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false">
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p1">验证账户</p>
    <p class="p2 mt20">为了您的账户安全，请在进行相关操作前完成以下操作</p>
    <div class="box1 c-flex-align-center">
      <div class="c-flex c-flex-align-center">
        <img
          src="@/assets/img/images/icon/warning-icon.png"
          alt="warning-icon.png"
        />
        <p class="ml16">谷歌验证</p>
      </div>
      <div class="btn1">去设置</div>
    </div>
    <div class="box1 c-flex-align-center">
      <div class="c-flex c-flex-align-center">
        <img
          src="@/assets/img/images/icon/success-icon.png"
          alt="warning-icon.png"
        />
        <p class="ml16">交易密码</p>
      </div>
      <div class="btn3">已完成</div>
    </div>

    <div class="btn2" @click="dialogVisible = false">关闭</div>
  </el-dialog>
</template>

<script>
import Tips from "@/components/Dialog/Tips.vue";
export default {
  components: {
    Tips,
  },
  data() {
    return {
      dialogVisible: false,
      formData: { name: "", password: "" },
    };
  },
  mounted() {},
  methods: {
    shouTipsClick() {
      this.$refs.tipsRef.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 540px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.box1 {
  display: flex;
  padding: 32px 0;
  justify-content: space-between;
  border-bottom: 1px solid #e2e3e3;
  img {
    width: 40px;
    height: 40px;
  }
  .btn1 {
    width: 94px;
    height: 40px;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    background: #4063ff;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
  }
  .btn3 {
    width: 94px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #b9b9b9;
  }
  p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn2 {
  width: 100%;
  height: 48px;
  cursor: pointer;
  line-height: 48px;
  text-align: center;
  background: #3370ff;
  border-radius: 8px 8px 8px 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #ffffff;
}
</style>
